export default function Logistic_Regression() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Logistic_Regression</h1>
      <p>Content for Logistic_Regression goes here.</p>
    </div>
  );
}